import { Icon } from '@iconify/react';

const IconifyIcon = ({ icon, marginRight, ...rest }) => {
  return <Icon icon={icon} fontSize='1rem' style={{ marginRight }} {...rest} />
}

export default IconifyIcon;
